import React from 'react'

const SectionThree = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, setMessageBoard, setErrorTabEnable } = props
    return (
        <>
            <div className="error-message-head1">Check the Weather Conditions</div>
            <div className="error-message-head2">Check if it is cloudy/raining</div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        handleButtonClick(3, "yes");
                        setMessageBoard(false);
                        setErrorTabEnable(false);
                    }}
                    className={`error-button ${toggleOption[3] === "yes" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[3]}
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        handleButtonClick(3, "no");
                        setSelectedOptions([true, true, true, true, false, false, false]);
                    }}
                    className={`error-button ${toggleOption[3] === "no" ? "clicked" : ""
                        }`}
                    disabled={selectedOptions[3]}
                >
                    No
                </button>
            </div>
            <div className="error-message-head2">
                Continue with Troubleshooting Steps
            </div>
            <div className="error-message-head2">
                Check if the connector at the box end is properly placed or connected
            </div>
            <div className="error-message-head2">
                If is not properly connected, request subscriber to tighten the
                connector and check for resumption of service
            </div>
        </>
    )
}

export default SectionThree
